interface AppConfig {
  apiBaseUrl: string;
  envName: string;
}

let config: AppConfig = {
  apiBaseUrl: '',
  envName: '',
};

export async function loadConfig(): Promise<AppConfig> {
  try {
    const res = await fetch('/config.json');
    config = await res.json();
  } catch {
    // fallback for local dev without config.json
    config = { apiBaseUrl: '', envName: 'local' };
  }
  return config;
}

export function getConfig(): AppConfig {
  return config;
}
